<template>
	<v-img v-bind="$attrs" :src="imageUrl"/>
</template>

<script>
export default {
	name: "Image",

	props: {
		img: {
			type: String,
			require: true
		}
	},

	computed: {
		imageUrl() {
			return this.isUrl(this.img) ? this.img : new URL(`../assets/images/${this.img}`, import.meta.url).href;
		}
	},

	methods: {
		isUrl(urlString) {
			try {
				return Boolean(new URL(urlString));
			} catch (e) {
				return false;
			}
		}
	}
}
</script>